import React, { useState, type FC } from 'react';
import { Helmet } from 'react-helmet-async';

import { Space, Text } from '@g2u/ui-kit';
import { Select } from 'antd';

import { useCustomerTickets } from '../hooks/useCustomerTickets';
import styles from '../edit.module.scss';
import { CreateTicketModal, TicketList } from 'components';

export namespace CustomerTickets {
  export type Props = Readonly<{
    customerId?: string;
  }>;

  export const $: FC<Props> = (props) => {
    const { customerId } = props;
    const [status, setStatus] = useState<'0' | '1' | null>(null);
    const { tickets, paginationMetadata, isTicketsLoading } = useCustomerTickets(status, customerId);

    const [isCreateModalOpen, setCreateModalOpen] = useState<boolean>();

    return (
      <>
        <Helmet>
          <title>Customer Tickets</title>
        </Helmet>
        <Space.$
          direction={Space.Direction.Vertical}
          size={Space.Size.ExtraLarge}
          fullWidth
          className={styles.edit__content}
        >
          <Space.$ justify={Space.Justify.SpaceBetween}>
            <span>
              <Text.$>Status : </Text.$>
              <Select
                style={{ width: 150 }}
                defaultValue={null}
                options={[
                  {
                    label: 'All',
                    value: null,
                  },
                  {
                    label: 'Open',
                    value: '1',
                  },
                  {
                    label: 'Closed',
                    value: '0',
                  },
                ]}
                onChange={(val) => setStatus(val)}
              />
            </span>
          </Space.$>
          <TicketList.$
            tickets={tickets}
            paginationMetadata={paginationMetadata}
            isLoading={isTicketsLoading}
            onAdd={() => setCreateModalOpen(true)}
            hideColumns={['customer']}
          />
        </Space.$>
        <CreateTicketModal.$
          customerId={customerId}
          isOpen={!!isCreateModalOpen}
          onClose={() => setCreateModalOpen(false)}
        />
      </>
    );
  };
}
